var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _g, _path49;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoteSignLeft2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 457,
    viewBox: "0 0 423 457",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288.77 415.54C288.77 415.54 316.93 402.43 322.8 394.75C324.77 387.55 302.78 392.56 302.78 392.56L288.77 415.54Z",
    fill: "#623A18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M343.94 323.2C343.94 323.2 338.68 314.91 312.33 321.92C302.63 328.94 315.63 339.97 315.63 339.97L343.94 323.2Z",
    fill: "#301E10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M329.792 352.357L315.605 351.758L313.969 390.463L328.157 391.063L329.792 352.357Z",
    fill: "#301E10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M339.75 351.59C339.75 351.59 335.35 346.51 323.74 346.23C320.28 352.29 323.16 357.12 323.16 357.12L339.75 351.59Z",
    fill: "#301E10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M321.73 337.29C307.09 339.9 301.96 343.73 301.96 343.73L318.69 389.21L288.78 415.55C288.78 415.55 259.52 427.47 241.19 414.14C231.91 390.86 234.66 357.59 234.66 357.59C234.66 357.59 278.42 331.2 286.05 327.92C293.69 324.64 295.47 322.87 315.37 321.43",
    fill: "#623A18"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M321.26 358.38C318.05 363.61 313.46 367.88 308.58 371.59C296.31 380.91 281 386.06 265.64 386.56C262.6 386.68 259.52 386.43 256.49 386.23C258 385.94 259.49 385.69 260.99 385.46C265.26 384.84 270.03 383.89 274.21 382.81C291.48 378.5 308.04 370.5 321.26 358.39V358.38Z",
    fill: "#623A18"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M319.332 235.12L294.217 236.234L302.628 425.857L327.744 424.743L319.332 235.12Z",
    fill: "#F2C744"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M319.49 238.34L319.9 247.63C309.14 247.95 297.48 250.82 295.25 259.27L294.37 239.45L319.49 238.33V238.34Z",
    fill: "#F2C744"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M300.9 243.24C368.069 243.24 422.52 188.789 422.52 121.62C422.52 54.4511 368.069 0 300.9 0C233.731 0 179.28 54.4511 179.28 121.62C179.28 188.789 233.731 243.24 300.9 243.24Z",
    fill: "#F2C744"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M401.35 65.1299C404.88 71.3999 407.84 78.0399 410.17 84.9799",
    stroke: "#F2C744",
    strokeWidth: 4.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M295.58 6.52C334.34 4.73 369.51 22.3 391.72 50.7",
    stroke: "#F2C744",
    strokeWidth: 4.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M300.9 229.97C360.74 229.97 409.25 181.46 409.25 121.62C409.25 61.78 360.74 13.27 300.9 13.27C241.06 13.27 192.55 61.78 192.55 121.62C192.55 181.46 241.06 229.97 300.9 229.97Z",
    fill: "#F2C744"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M300.9 223.38C357.101 223.38 402.66 177.821 402.66 121.62C402.66 65.4196 357.101 19.8601 300.9 19.8601C244.7 19.8601 199.14 65.4196 199.14 121.62C199.14 177.821 244.7 223.38 300.9 223.38Z",
    fill: "#F3F4F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M299.48 54.9399L300.14 69.8599L295.54 70.0599L281.51 117.06L264.81 117.8L246.67 72.2299L242.07 72.4299L241.41 57.5099L264.28 56.4899L264.94 71.4099L262.87 71.4999L272.29 97.9899L279.32 70.7699L277.25 70.8599L276.59 55.9399L299.46 54.9199L299.48 54.9399Z",
    fill: "#265CA9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M352.34 61.25L354.29 105.16L345.88 114.2L317.88 115.44L308.7 107.19L306.75 63.28L315.16 54.24L343.16 53L352.34 61.25Z",
    fill: "#CD2027"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M248.05 129.39L301.22 127.03L302.23 149.67L287.16 150.34L286.82 142.61L282.84 142.79L284.24 174.23L288.07 174.06L288.73 188.9L266.01 189.91L265.35 175.07L269.18 174.9L267.78 143.46L263.8 143.64L264.14 151.37L249.07 152.04L248.06 129.4L248.05 129.39Z",
    fill: "#CD2027"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M343.76 147.83L343.42 140.1L327.58 140.8L327.95 149.06L341.03 148.48L341.69 163.32L328.61 163.9L328.98 172.24L344.43 171.55L344.09 163.9L359.31 163.22L360.31 185.71L310.97 187.9L310.31 173.06L314.14 172.89L312.74 141.45L308.91 141.62L308.25 126.7L339.77 125.3L342.88 128L342.75 125.17L357.59 124.51L358.6 147.15L343.76 147.81V147.83Z",
    fill: "#265CA9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M329.71 65.9099L331.98 71.9699L338.45 71.6899L333.38 75.7199L335.66 81.7899L330.25 78.2199L325.18 82.2499L326.91 76.0099L321.51 72.4399L327.98 72.1499L329.71 65.9099Z",
    fill: "#F3F4F5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M330.62 86.4199L332.89 92.4799L339.36 92.1999L334.29 96.2299L336.57 102.3L331.16 98.7299L326.1 102.76L327.82 96.5199L322.42 92.9499L328.89 92.6599L330.62 86.4199Z",
    fill: "#F3F4F5"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M313.73 258.42L319.03 373.29",
    stroke: "#F2C744",
    strokeWidth: 4.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M319.73 388.28L320.27 400.09",
    stroke: "#F2C744",
    strokeWidth: 4.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9299 377.49C91.5799 374.92 198.07 371.8 234.66 357.59C260.6 345.31 241.19 414.14 241.19 414.14C241.19 414.14 124.15 441.28 103 451.87C90.2899 422.39 89.9399 377.49 89.9399 377.49H89.9299Z",
    fill: "#623A18"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M180.12 389.38C189.02 390.39 197.09 386.48 205.7 385.31C209.96 384.61 214.37 384.17 218.6 383.55C222.7 382.85 227.02 381.47 228.74 377.26C228.64 378.36 228.29 379.46 227.69 380.46C223.51 386.88 212.97 387 206.19 388.43C197.61 389.54 188.51 392.92 180.11 389.39L180.12 389.38Z",
    fill: "#623A18"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M182.42 401.97C184.61 397.95 189.41 396.1 193.57 394.88C197.8 393.65 202.07 392.6 206.38 391.74C210.71 390.88 215 390.19 219.44 389.72C222.74 389.35 226.95 389.88 229.13 392.83C229.84 393.77 230.28 394.91 230.25 396.02C229.59 393.87 227.72 392.57 225.82 392.05C223.9 391.52 221.84 391.76 219.78 392.15C215.58 393.04 211.26 393.99 207 394.82C202.73 395.68 198.43 396.48 194.14 397.25C189.92 398.05 185.64 398.87 182.42 401.97Z",
    fill: "#623A18"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M325.23 351.67C326.41 350.99 327.8 350.71 329.16 350.4C332.56 349.63 337.48 348.97 340.07 351.92C340.72 352.66 341.13 353.58 341.35 354.53C341.47 355.05 341.53 355.59 341.53 356.12C341.5 358.97 339.55 361.25 337.36 362.85C334.64 364.84 331.37 366.21 328.12 367.06C327.75 367.16 327.43 367.22 327.04 367.15C326.45 367.04 325.93 366.68 325.53 366.23C324.75 365.37 324.08 364.21 323.55 363.18C322.98 362.09 322.55 360.93 322.3 359.72C321.84 357.46 322.28 354.84 323.7 352.99C324.14 352.42 324.67 351.99 325.24 351.65L325.23 351.67Z",
    fill: "#623A18"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M325.58 354.45C325.58 354.45 323.8 360.22 327.45 364.96C333.19 363.59 333.7 363.04 333.7 363.04C334.42 361.82 333.09 355.11 331.88 354.58C328.87 354.19 325.59 354.46 325.59 354.46L325.58 354.45Z",
    fill: "#CFABA1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M335.16 353.52C337.77 354.95 339.07 358.84 337.1 361.28C335.57 358.85 334.63 356.41 335.16 353.52Z",
    fill: "#623A18"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M321.81 328.34C322.85 327.47 324.17 326.95 325.45 326.4C328.66 325.04 340.86 320.74 343.94 323.19C344.71 323.8 345.27 324.63 345.66 325.54C345.87 326.03 346.02 326.55 346.11 327.08C346.58 329.89 345.06 332.48 343.19 334.44C340.86 336.88 330.4 341.59 327.36 343C327.01 343.16 326.71 343.28 326.31 343.28C325.71 343.28 325.13 343.01 324.66 342.64C323.74 341.93 322.88 340.91 322.17 339.99C321.42 339.02 320.79 337.95 320.33 336.8C319.48 334.65 319.45 332 320.53 329.93C320.86 329.29 321.3 328.77 321.82 328.34H321.81Z",
    fill: "#623A18"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M322.65 331.03C322.65 331.03 321.92 337.02 326.33 341.05C331.74 338.69 332.14 338.06 332.14 338.06C332.63 336.74 330.15 330.36 328.86 330.05C325.83 330.2 322.64 331.03 322.64 331.03H322.65Z",
    fill: "#CFABA1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M331.91 328.42C334.73 329.37 336.69 332.97 335.18 335.72C333.25 333.6 331.89 331.36 331.91 328.42Z",
    fill: "#623A18"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M336.42 325.97C339.24 326.92 341.2 330.52 339.69 333.27C337.76 331.15 336.4 328.91 336.42 325.97Z",
    fill: "#623A18"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M325.31 367.83C325.59 367.58 325.9 367.37 326.27 367.21C326.95 366.92 327.65 366.63 328.35 366.38C329.99 365.79 331.71 365.34 333.46 365.25C337.07 365.07 339.93 366.85 340.93 370.4C342.09 374.51 339.51 377.68 336.06 379.55C334.65 380.31 333.15 380.89 331.62 381.36C330.44 381.72 329.16 382.25 327.9 382.05C326.66 381.86 325.87 381.22 325.22 380.21C324.68 379.37 324.21 378.48 323.86 377.54C322.97 375.19 322.88 372.62 323.81 370.27C324.18 369.35 324.61 368.46 325.32 367.82L325.31 367.83Z",
    fill: "#623A18"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M326.7 369.89C326.7 369.89 324.98 375.36 328.16 379.72C332.3 378.85 333.43 378.33 333.43 378.33C333.9 376.69 332.21 371.36 331.34 369.73C329.22 369.37 326.69 369.89 326.69 369.89H326.7Z",
    fill: "#CFABA1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M333.49 368.48C336.74 369.95 338.09 374.49 336.06 377.5C334.53 374.56 333.74 371.78 333.49 368.48Z",
    fill: "#623A18"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M326.43 394.53C326.43 394.53 322.31 395.01 322.33 388.47C322.35 381.93 328.14 381.84 328.14 381.84C328.14 381.84 331.57 381.92 331.12 388C330.66 394.07 326.43 394.53 326.43 394.53Z",
    fill: "#623A18"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M326.09 384.35C325.42 384.44 324.6 386.31 324.47 386.72C323.9 388.41 324.16 390.23 324.82 391.85C324.99 392.28 325.23 393.29 325.84 393.22C326.29 393.17 326.6 392.41 326.75 392.04C326.95 391.57 327.07 391.06 327.18 390.56C327.52 389.02 327.63 387.25 327.12 385.73C326.98 385.3 326.71 384.66 326.32 384.41C326.25 384.36 326.17 384.35 326.09 384.36V384.35Z",
    fill: "#CFABA1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M329.08 384.06C331.23 386.36 331.11 390.81 328.31 392.55C328.67 389.52 328.57 387.17 329.08 384.06Z",
    fill: "#623A18"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M225.11 423.94C151.51 442.31 75.9 451.35 0.0400391 450.85C0.200039 427.42 0.350039 404 0.510039 380.57C70.47 381.04 140.21 372.7 208.09 355.75C213.76 378.48 219.44 401.21 225.11 423.93V423.94Z",
    fill: "#E2E2E2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M216.47 432.26C145.57 449.1 72.89 457.37 0 456.89C0.18 429.44 0.37 401.98 0.55 374.53C66.85 374.97 132.95 367.45 197.44 352.13C203.79 378.84 210.13 405.55 216.48 432.26H216.47Z",
    fill: "#265CA9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M185.54 373.38C182.55 374.03 179.63 372.17 179.02 369.26C178.41 366.34 180.31 363.48 183.25 362.84C186.19 362.2 189.11 364.02 189.76 366.93C190.41 369.84 188.53 372.74 185.54 373.38Z",
    fill: "#64A3E2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M183.57 366.71C183.7 367.32 183.31 367.92 182.69 368.05C182.07 368.18 181.47 367.8 181.34 367.19C181.21 366.58 181.61 365.99 182.22 365.85C182.84 365.72 183.44 366.1 183.57 366.71Z",
    fill: "#124875"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M186.8 366C186.93 366.61 186.54 367.21 185.92 367.34C185.3 367.47 184.7 367.09 184.56 366.49C184.43 365.88 184.82 365.28 185.44 365.15C186.06 365.02 186.66 365.4 186.8 366Z",
    fill: "#124875"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M184.22 369.71C184.35 370.32 183.96 370.92 183.34 371.05C182.72 371.18 182.11 370.8 181.98 370.19C181.85 369.58 182.25 368.98 182.86 368.85C183.48 368.72 184.09 369.1 184.22 369.71Z",
    fill: "#124875"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M187.46 369.01C187.59 369.62 187.2 370.22 186.58 370.35C185.96 370.49 185.35 370.1 185.22 369.5C185.09 368.89 185.48 368.29 186.1 368.16C186.72 368.02 187.33 368.41 187.46 369.01Z",
    fill: "#124875"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M234.66 357.59C234.66 357.59 239.56 329.69 265.28 312.17C278.35 302.28 283.61 287.39 283.88 285.35C284.17 283.14 289.41 275.98 293.98 279.45C298.55 282.91 297.52 290.49 297.48 292.43C297.44 294.37 291.71 312.94 279.87 327.25C271.72 338.9 272.18 346.07 272.18 346.07C272.18 346.07 260.07 362.53 234.67 357.6L234.66 357.59Z",
    fill: "#623A18"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M260.19 315.98C263.92 315.77 268.61 318.3 269.22 322.24C265.96 320.59 262.51 318.95 260.19 315.98Z",
    fill: "#623A18"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M254.07 321.63C257.08 321.36 260.92 323.62 261.05 326.87C258.17 325.8 255.55 324.47 254.07 321.63Z",
    fill: "#623A18"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2062_407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 234,
    y: 278,
    width: 64,
    height: 81
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M234.66 357.59C234.66 357.59 239.56 329.69 265.28 312.17C278.35 302.28 283.61 287.39 283.88 285.35C284.17 283.14 289.41 275.98 293.98 279.45C298.55 282.91 297.52 290.49 297.48 292.43C297.44 294.37 291.71 312.94 279.87 327.25C271.72 338.9 272.18 346.07 272.18 346.07C272.18 346.07 260.07 362.53 234.67 357.6L234.66 357.59Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2062_407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.22 281.36C286.22 281.36 289.83 284.66 288.04 291.35C286.25 298.04 285.62 298.07 285.62 298.07L279.91 294.14C279.91 294.14 280.51 283.05 286.22 281.36Z",
    fill: "#CFABA1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M276.21 333.14C276.98 345.43 265.7 356.46 254.39 359.35C255.46 358.24 256.6 357.31 257.7 356.34C265.21 349.71 272.18 342.51 276.22 333.15L276.21 333.14Z",
    fill: "#623A18"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteSignLeft2);
export default __webpack_public_path__ + "static/media/VoteSignLeft2.c8bc11cdd986908c59a348babc037e05.svg";
export { ForwardRef as ReactComponent };